export const calculateAmountDiscountCents = (subtotalCents: number, totalCents: number, serviceFeeCents = 0): number =>
  Math.max(subtotalCents + serviceFeeCents - totalCents, 0);
